import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    searchParams: {
        id: "",
        name: "",
        code: ""
    },
}

const accountSlice = createSlice({
    name: 'account',
    initialState,
    reducers: {
        setAccountSearchParamsAction: (state, action) => {
            const { key, value } = action.payload
            state.searchParams = { ...state.searchParams, [key]: value }
        }
    },
});

export const { setAccountSearchParamsAction } = accountSlice.actions;
export default accountSlice;